<template>
  <div>
    <b-modal
      id="ed-permissions-background-info"
      title="Permisos en proceso"
      v-model="showBackgroundModal"
      centered
      ok-only
      ok-title="Entendido"
      ok-variant="primary"
      @hidden="closeBackgroundModal"
      no-close-on-backdrop
    >
      <div class="text-center p-3">
        <feather-icon icon="ClockIcon" size="48" class="text-primary mb-2" />
        <p class="mt-2">
          Los permisos se están asignando en segundo plano.
          <br><br>
          <strong>Te notificaremos por correo electrónico cuando el proceso termine.</strong>
        </p>
      </div>
    </b-modal>
    <b-modal
      id="ed-permissions-form-container"
      title="Permisos"
      v-model="showModal"
      hide-footer
      centered
    >
    <form data-vv-scope="ed-permissions-form">
      <div class="w-100 pl-5 pr-5 mb-32">
        <b-form-group
          label="Selecciona el tipo de permiso"
          label-for="referenceType"
        >
          <vs-select
            class="w-100"
            autocomplete
            label=""
            id="referenceType"
            name="referenceType"
            v-model="referenceType"
            :danger="errors.has('ed-permissions-form.referenceType')"
            :danger-text="errors.first('ed-permissions-form.referenceType')"
            v-validate="'required'"
            :disabled="permission !== null"
          >
            <vs-select-item
              :value="referenceTypes.USER"
              text="Usuario"
            />
            <vs-select-item
              :value="referenceTypes.GROUP"
              text="Grupo"
            />
          </vs-select>
        </b-form-group>
        <b-form-group
          v-if="referenceType === referenceTypes.USER"
          label="(*) Usuario"
          label-for="selectedUserId"
        >
          <ListUser
            autocomplete
            v-model="selectedUserId"
            id="selectedUserId"
            name="selectedUserId"
            label=""
            placeholder="Seleccione un usuario..."
            :danger="errors.has('ed-permissions-form.selectedUserId')"
            :danger-text="errors.first('ed-permissions-form.selectedUserId')"
            v-validate="{ required: referenceType === referenceTypes.USER }"
            v-if="permission === null"
            :show-option-all="true"
          />
          <vs-select
            v-else
            class="w-100"
            autocomplete
            label=""
            v-model="selectedUserId"
            disabled
          >
            <vs-select-item
              :value="permission.idEntidad"
              :text="permission.nombreEntidad"
            />
          </vs-select>
        </b-form-group>
        <b-form-group
          v-if="referenceType === referenceTypes.GROUP"
          label="(*) Grupo"
          label-for="selectedGroupId"
        >
          <ListGroups
            class="w-100"
            autocomplete
            label=""
            id="selectedGroupId"
            name="selectedGroupId"
            v-model="selectedGroupId"
            :typeList="stepTypes.GROUP"
            ref="selectedGroupId"
            data-vv-as="Grupo"
            :danger="errors.has('ed-permissions-form.selectedGroupId')"
            :danger-text="errors.first('ed-permissions-form.selectedGroupId')"
            v-validate="{ required: referenceType === referenceTypes.GROUP }"
            :disabled="permission !== null && fromEditor"
          />
        </b-form-group>
        <b-form-group data-cy="permissions">
          <label >Permisos</label>
          <b-form-checkbox
            v-model="read"
            :value="1"
            :unchecked-value="0"
            :disabled="owner"
          >
            Lectura
          </b-form-checkbox>
          <b-form-checkbox
            v-model="write"
            :value="1"
            :unchecked-value="0"
            :disabled="owner"
          >
            Escritura
          </b-form-checkbox>
          <b-form-checkbox
            v-model="totalControl"
            :value="1"
            :unchecked-value="0"
            :disabled="owner"
          >
            Control total
          </b-form-checkbox>
        </b-form-group>
        <hr>
        <b-form-group>
          <b-form-checkbox
            v-model="applyToChildren"
            :disabled="owner"
          >
            Aplicar estos permisos a los archivos y carpetas interiores
          </b-form-checkbox>
        </b-form-group>
      </div>
      <div v-if="owner" class="message-owner">
        No es posible cambiar los permisos del propietario.
      </div>
      <div v-if="alreadyExists && !fromEditor" class="message-exists">
        Ya se habian configurado estos permisos, puedes cambiarlos si lo necesitas.
      </div>
      <div v-if="noPermissions" class="message-exists">
        Debes seleccionar al menos 1 permiso para poder guardar. Si estas editando y quieres quitar
        todos los permisos, debes eliminar la asignación desde el panel de permisos.
      </div>
      <vs-divider class="pt-32" />
      <div class="d-flex justify-end">
        <b-button
          class="ml-3"
          :class="{ 'cursor-not-allowed': disabledSaveBtn }"
          v-on:click="save"
          variant="outline-primary"
          :disabled="disabledSaveBtn"
        >
          Guardar
          <span v-show="loading" class="spinner-border spinner-border-sm text-white" />
        </b-button>
        <b-button
          class="ml-3"
          variant="outline-danger"
          @click="clearForm"
        >
          Cancelar
          <span v-show="loading" class="spinner-border spinner-border-sm text-white" />
        </b-button>
      </div>
    </form>
  </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import {
  ioEDPermissionsAdd, ioEDPermissionsUpdate
} from '@/febos/servicios/api/repositories.api';
import ListUser from '@/febos/chile/lists/components/ListUser';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ReferenceTypes from '@/febos/global/documentManagement/mixins/ReferenceTypes';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';

export default {
  name: 'EDPermissionsForm',
  props: {
    selectedPermission: {
      type: Object,
      required: false,
      default: () => null
    },
    element: {
      type: Object,
      required: false,
      default: () => {}
    },
    list: {
      type: Array,
      required: false,
      default: () => []
    },
    loadPermissions: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      permission: null,
      selectedUserId: '',
      selectedGroupId: '',
      elementId: '',
      owner: false,
      read: 0,
      write: 0,
      totalControl: 0,
      fromEditor: false,
      alreadyExists: false,
      loading: false,
      showBackgroundModal: false,
      referenceType: ReferenceTypes.USER,
      referenceTypes: ReferenceTypes,
      stepTypes: StepTypes,
      referenceTypeOptions: [
        { label: 'Usuario', value: ReferenceTypes.USER },
        { label: 'Grupo', value: ReferenceTypes.GROUP }
      ],
      applyToChildren: false
    };
  },
  components: {
    ListUser,
    ListGroups
  },
  beforeMount() {
    if (this.selectedPermission) {
      this.fromEditor = true;
      this.permission = this.selectedPermission;
      this.loadPermission();
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('DocManagement', [
      'loadPermissionsElement'
    ]),
    loadPermission() {
      this.elementId = this.getSelectedElement.id;
      this.read = this.permission.lectura;
      this.write = this.permission.escritura;
      this.applyToChildren = this.permission.todoPermisos === 'Y';
      this.totalControl = this.permission.controlTotal;
      this.referenceType = this.permission.tipoEntidad;
      if (this.referenceType === 'U') {
        this.selectedUserId = this.permission.idEntidad;
      } else if (this.referenceType === 'G') {
        this.selectedGroupId = this.permission.idEntidad;
      }
    },
    clearForm() {
      this.selectedUserId = '';
      this.selectedGroupId = '';
      this.elementId = '';
      this.read = 0;
      this.write = 0;
      this.totalControl = 0;
      this.loading = false;
      this.$validator.reset();
      setTimeout(() => {
        this.closeModal();
      }, 100);
    },
    isInPermissionList(id) {
      for (let i = 0; i < this.list.length; i += 1) {
        if (this.list[i].idEntidad === id) {
          this.permission = this.list[i];
          this.alreadyExists = true;
          this.loadPermission();
          return true;
        }
      }
      this.alreadyExists = false;
      return false;
    },
    async save() {
      if (this.loading) {
        return;
      }
      const formCheck = await this.$validator.validateAll('ed-permissions-form');
      if (formCheck) {
        this.loading = true;
        if (this.permission) {
          const response = await ioEDPermissionsUpdate({
            permissionId: this.permission.permisoId,
            repositoryId: this.getSelectedElement.repositoryId,
            elementId: this.getSelectedElement.id,
            read: this.read,
            write: this.write,
            totalControl: this.totalControl,
            params: { todoPermisos: this.applyToChildren }
          });
          if (response && response.data && response.data.tareaId) {
            this.loading = false;
            this.showBackgroundModal = true;
            return;
          }
          this.$emit('update-permissions');
        } else {
          const response = await ioEDPermissionsAdd({
            repositoryId: this.getSelectedElement.repositoryId,
            elementId: this.getSelectedElement.id,
            referenceId: this.referenceId,
            referenceType: this.referenceType,
            read: this.read,
            write: this.write,
            totalControl: this.totalControl,
            params: { todoPermisos: this.applyToChildren }
          });
          if (response && response.data && response.data.tareaId) {
            this.loading = false;
            this.showBackgroundModal = true;
            return;
          }
          this.$emit('update-permissions');
        }
        await this.loadPermissionsElement({
          elementId: this.getSelectedElement.id,
          repositoryId: this.getSelectedElement.repositoryId
        });
        await this.loadPermissions();
        this.loading = false;
        this.closeModal();
      }
    },
    closeBackgroundModal() {
      this.showBackgroundModal = false;
      this.closeModal();
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedElement'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    noPermissions() {
      const sum = this.read + this.write + this.totalControl;
      return sum === 0;
    },
    showModal: {
      get() {
        return this.modalName === 'EDPermissionsForm';
      },
      set() {
        this.closeModal();
      },
    },
    referenceId() {
      let response = '';
      if (this.referenceType === this.referenceTypes.USER) {
        response = this.selectedUserId;
      } else if (this.referenceType === this.referenceTypes.GROUP) {
        response = this.selectedGroupId;
      }
      return response;
    },
    disabledSaveBtn() {
      if (this.noPermissions || this.owner || this.loading) {
        return true;
      } return false;
    }
  },
  watch: {
    read(val) {
      if (val === 0) {
        this.write = 0;
        this.totalControl = 0;
      }
    },
    write(val) {
      if (val === 1) {
        this.read = 1;
      } else {
        this.totalControl = 0;
      }
    },
    totalControl(val) {
      if (val === 1) {
        this.read = 1;
        this.write = 1;
      }
    },
    selectedUserId(id) {
      console.log(id, this.element.ownerId, id === this.element.ownerId);
      if (id === this.element.ownerId) {
        this.owner = true;
      } else {
        this.owner = false;
        if (!this.isInPermissionList(id)) {
          this.permission = null;
        }
      }
    },
    selectedGroupId(id) {
      this.owner = false;
      if (!this.isInPermissionList(id)) {
        this.permission = null;
      }
    }
  }
};
</script>

<style>
.fb-bg-primary{
  background-color: rgb(var(--vs-primary)) !important;
  border-color: rgb(var(--vs-primary)) !important;
}
.btn-outline-primary{
  border-color: rgb(var(--vs-primary)) !important;
}
.btn-outline-primary:hover{
  background-color: rgb(var(--vs-primary)) !important;
}
.message-owner{
  padding: 5px;
  background-color: #f8d7da;
  border: solid 1px #f5c6cb;
  color: #721c24;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
  text-align: center;
}

.message-exists {
  padding: 5px;
  background-color: #fff3cd;
  border: solid 1px #ffeeba;
  color: #856404;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
  text-align: center;
}

</style>
